import {IDisposableLike} from "../Tools/Disposable/IDisposableLike";

export class Header implements IDisposableLike{
    private jqMainContainer: JQuery | undefined;
    private jqContainer: JQuery | undefined;

    constructor(options: IHeaderOption) {
        this.jqMainContainer = options.jqMainContainer;

        this.#init();

    }

    #init = () => {
        this.buildHtml();
    }

    private buildHtml = () => {
        this.jqMainContainer.empty();
        this.jqContainer = $("<div></div>");
        this.jqMainContainer.append(this.jqContainer);
        this.jqContainer.css({
            height: "100%",
            width: "100%",
            margin: 0,
            padding: 0,
            display: "flex",
            "flex-direction": "row"
        });
        this.buildIgm();
    }

    private buildIgm = () => {
        const img = $("<img/>");
        img.attr("src", "/img/logo.png");
        img.width(79);
        this.jqContainer.append(img);
    }
    
    public Dispose = () => {
        this.jqContainer.remove();
    }
}

export interface IHeaderOption {
    jqMainContainer: JQuery;
}
